<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Novo Cliente IKAcesso</h5>
                <hr>                
                <FormCliente ref="formCliente"/>
                <Panel header="Licença" class="p-mt-3 p-mb-3">
                    <div class="p-fluid p-formgrid p-grid">                        
                        <div class="p-field p-col-6 p-md-6">
                            <label>Pacote de Permissões</label>                           
                            <Dropdown v-model="licenca.descricao" :options="pacotes" optionLabel="nome" optionValue="valor"/>
							<small class="p-invalid" v-if="enviandoForm && !licenca.descricao">Selecione o pacote de permissões</small>
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid p-grid">                        
                        <div class="p-field p-col-6 p-md-6">
                            <label>Quantidade de Equipamentos</label>                           
                            <InputNumber v-model.trim="licenca.quantidadeEquipamentos" :useGrouping="false" />
							<small class="p-invalid" v-if="enviandoForm && !licenca.quantidadeEquipamentos">Informe a quantidade de equipamentos</small>
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid p-grid">                        
                        <div class="p-field p-col-6 p-md-6">
                            <label>Validade (em meses)</label>                           
                            <InputNumber v-model.trim="licenca.quantidadeMeses" :useGrouping="false" />
							<small class="p-invalid" v-if="enviandoForm && !licenca.quantidadeMeses">Informe a quantidade de meses</small>
                        </div>
                    </div>                    
                </Panel>              
                <Button label="Fechar" class="p-button-secondary" icon="pi pi-times" @click="fechar"/>
                <Button label="Salvar" class="p-ml-2" icon="pi pi-check" @click="salvar"/>
            </div>
        </div>
    </div>
</template>

<script>

import FormCliente from '@/components/pages/cadastro/cliente-ikacesso/FormCliente.vue';
import ClienteIKAcessoService from '@/service/ClienteIKAcessoService.js';
import { exibirMensagemSis } from '@/global';
import Cliente from '@/model/ClienteIKAcesso.js';
import Licenca from '@/model/LicencaIKAcesso.js';
import { mapGetters } from 'vuex';

export default {
    clienteService: null,
    data() {
        return {
            enviandoForm: false,
            pacotes: [],
            cliente: new Cliente(),     
            licenca: new Licenca(),      
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        salvar() {
            let cliente = this.$refs.formCliente.getDados();
            if(!cliente) {
                return;
            }
            this.licenca.sistemaAcesso = false;
            this.licenca.sistemaEscola = false;
            this.licenca.sistemaRefeicao = false;
            this.pacotes.forEach(pacote => {
                if(this.licenca.descricao == pacote.nome) {
                    this.licenca.sistemaAcesso = pacote.permissao.sistemaAcesso;
                    this.licenca.sistemaEscola = pacote.permissao.sistemaEscola;
                    this.licenca.sistemaRefeicao = pacote.permissao.sistemaRefeicao;
                }
            });
            let requisicao = {
                cliente: cliente,
                licenca: this.licenca
            }
            this.clienteService.salvar(requisicao)
            .then(resp => {		
				if(resp.data.status == 200) {
                    exibirMensagemSis(this, resp.data.entity.mensagem, false);
                    setTimeout(() => {
						this.fechar();
					}, 1000);
                } else {
                    exibirMensagemSis(this, resp.data.entity.mensagem, true);
                }
            }).catch(erro => {              
                if(erro.response && erro.response.data.status == 401) {
                    exibirMensagemSis(this, erro.response.data.message, true);
                } else {
                    exibirMensagemSis(this, 'Erro interno do servidor', true);
                    console.log(erro.request)
                } 
            });
        },
        fechar() {
            this.$router.push('/cadastro/clientes/ikacesso');
        },
        carregarPacotesPermissoes() {
            this.licenca.descricao = 'Acesso';
            this.pacotes.push({ nome: 'Acesso', valor: 'Acesso', permissao: { sistemaAcesso: true, sistemaEscola: false, sistemaRefeicao: false } });
            this.pacotes.push({ nome: 'Acesso + Escola', valor: 'Acesso + Escola', permissao: { sistemaAcesso: true, sistemaEscola: true, sistemaRefeicao: false }  });
            this.pacotes.push({ nome: 'Acesso + Refeição', valor: 'Acesso + Refeição', permissao: { sistemaAcesso: true, sistemaEscola: false, sistemaRefeicao: true }  });            
            this.pacotes.push({ nome: 'Acesso + Escola + Refeição', valor: 'Acesso + Escola + Refeição', permissao: { sistemaAcesso: true, sistemaEscola: true, sistemaRefeicao: true }  });             
        }
    },
    created() {
        this.carregarPacotesPermissoes();   
        this.clienteService = new ClienteIKAcessoService();    
    },
    components: {
        FormCliente
    }
}
</script>

<style>

</style>